import type { ISerpRowsConfigs } from "app/common/keyword-research/keywords-overview/serpMetricsTypes";
import { ESerpMetric } from "app/common/keyword-research/keywords-overview/serpMetricsTypes";

export const serpRowsConfigs: ISerpRowsConfigs[] = [
    {
        id: ESerpMetric.ORGANIC,
        title: "keyword.analysis.overview.page.v2.serp_metrics.organic.title",
        tooltip: "keyword.analysis.overview.page.v2.serp_metrics.organic.tooltip",
        displayNoData: true,
    },
    {
        id: ESerpMetric.PAID,
        title: "keyword.analysis.overview.page.v2.serp_metrics.paid.title",
        tooltip: "keyword.analysis.overview.page.v2.serp_metrics.paid.tooltip",
        displayNoData: true,
    },
    {
        id: ESerpMetric.CPC,
        title: "keyword.analysis.overview.page.v2.serp_metrics.cpc.title",
        tooltip: "keyword.analysis.overview.page.v2.serp_metrics.cpc.tooltip",
        displayNoData: true,
    },
];

export type SerpMetricRowData = Record<string, { value: string; change?: number; description?: string }>;
